import React, { useRef, useState } from 'react'
import OutlinedButtonWithLoader from './OutlinedButtonWithLoader'
import Modal from './Modal'
import { Exercise } from '../types'
import { useDispatch } from 'react-redux'
import { UPDATE_EXERCISE } from '../redux/exercisesReducer'
import { useParams } from 'react-router-dom'
import GapEditor from './GepEditor'

interface Props {
  exercise: Exercise
}

const EditExerciseButton = ({ exercise }: Props) => {
  const { lessonPlanId } = useParams()
  const [isOpen, setIsOpen] = useState(false)
  const toggleModal = () => setIsOpen(!isOpen)
  const [question, setQuestion] = useState(exercise.question)
  const [answer, setAnswer] = useState(exercise.answer)
  const dispatch = useDispatch()
  const editableRef = useRef<HTMLDivElement>(null)
  const handleSubmit = () => {
    if (exercise.question_type === 'fill_gap') {
      setQuestion(editableRef.current?.innerHTML || '')
      setAnswer(editableRef.current?.innerHTML || '')
    }
    dispatch(UPDATE_EXERCISE({ lessonPlanId: Number(lessonPlanId), exercise: { answer, question, id: exercise.id } }))
    toggleModal()
  }

  return (
    <>
      <OutlinedButtonWithLoader onClick={toggleModal} customClass="!w-24 !h-10 bg-slateGray" label="Edit" />
      <Modal isOpen={isOpen} toggleModal={toggleModal}>
        <div className="bg-white rounded-xl p-4 w-[500px] h-[fit-content] mt-20">
          <div className="text-18 font-semibold">Edit Exercise</div>
          <div className="h-4" />
          {exercise.question_type === 'type_answer' && (
            <div>
              <div>
                <div className="text-14 font-medium">Question</div>
                <div className="h-2" />
                <input
                  className="w-full border border-lightBorder/10 rounded-lg p-2"
                  value={question}
                  onChange={(e) => setQuestion(e.target.value)}
                />
              </div>
              <div className="h-4" />
              <div>
                <div className="text-14 font-medium">Answer</div>
                <div className="h-2" />
                <input
                  className="w-full border border-lightBorder/10 rounded-lg p-2"
                  value={answer}
                  onChange={(e) => setAnswer(e.target.value)}
                />
              </div>
            </div>
          )}

          {exercise.question_type === 'fill_gap' && (
            <div>
              <div className="text-14 font-medium">Question</div>
              <div className="h-2" />
              <GapEditor initialValue={question} editableRef={editableRef} />
            </div>
          )}

          <div className="h-6" />
          <div className="flex justify-end">
            <button onClick={handleSubmit} className="bg-slateGray text-white rounded-lg px-4 py-2">
              Save Changes
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default EditExerciseButton
